<template>
  <NuxtImg :src="headerLogo?.filename" :alt="headerLogo?.alt" />
</template>

<script setup lang="ts">
const { headerLogo } = await useConfigStore().asyncConfig()
</script>
